<!-- Two-button strip, no expansion panel here -->
<ng-container *ngIf="!isSpeaking; else speakingBtns">
  <!-- Speaker icon (start audio) -->
  <div class="disclosure-controls-row">
    <button
      mat-icon-button
      aria-label="Listen"
      (click)="onStartAudio($event)"
      class="action-button"
      [matTooltip]="'Listen'"
    >
      <mat-icon>volume_up</mat-icon>
    </button>

    <!-- Replace -->
    <button
      mat-icon-button
      [color]="replaceIsHovered ? 'primary' : 'secondary'"
      aria-label="Replace"
      (click)="makeReplacement($event)"
      class="action-button"
      [matTooltip]="'Replace'"
      (mouseover)="replaceIcon = 'check_circle'; replaceIsHovered = true"
      (mouseout)="replaceIcon = 'check_circle_outline'; replaceIsHovered = false"
    >
      <mat-icon>{{ replaceIcon || 'check_circle_outline' }}</mat-icon>
    </button>
  </div>
</ng-container>

<ng-template #speakingBtns>
  <!-- Stop while audio is playing -->
  <div class="disclosure-controls-row">
    <button
      mat-icon-button
      aria-label="Stop audio"
      (click)="onStopAudio($event)"
      class="action-button"
      [matTooltip]="'Stop'"
    >
      <mat-icon>stop</mat-icon>
    </button>

    <!-- Replace (also stops audio via handler) -->
    <button
      mat-icon-button
      [color]="replaceIsHovered ? 'primary' : 'secondary'"
      aria-label="Replace"
      (click)="makeReplacement($event)"
      class="action-button"
      (mouseover)="replaceIcon = 'check_circle'; replaceIsHovered = true"
      (mouseout)="replaceIcon = 'check_circle_outline'; replaceIsHovered = false"
    >
      <mat-icon>{{ replaceIcon || 'check_circle_outline' }}</mat-icon>
    </button>
  </div>
</ng-template>
